import * as types from "./actionTypes";
import * as customerAdminApi from "../../api/customerAdminApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadUsersSuccess(users) {
  return { type: types.LOAD_USERS_SUCCESS, users };
}

export function createUserSuccess(user) {
  return { type: types.CREATE_USER_SUCCESS, user };
}

export function updateUserSuccess(user) {
  return { type: types.UPDATE_USER_SUCCESS, user };
}

export function resendInviteSuccess(user) {
  return { type: types.RESEND_INVITE_SUCCESS, user };
}

export function loadUsers() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return customerAdminApi
      .getUsers()
      .then((users) => {
        dispatch(loadUsersSuccess(users));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveUser(user) {
  //eslint-disable-next-line no-unused-vars
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return customerAdminApi
      .saveUser(user)
      .then((savedUser) => {
        user.userId
          ? dispatch(updateUserSuccess(savedUser))
          : dispatch(createUserSuccess(savedUser));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function resendInvite(user) {
  //eslint-disable-next-line no-unused-vars
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return customerAdminApi
      .resendInvite(user)
      .then((savedUser) => {
          dispatch(resendInviteSuccess(savedUser));
        })
        .catch((error) => {          
          dispatch(apiCallError(error));
          throw error;
        });
  };
}
